export default __webpack_public_path__ + "static/media/rightArrowRed.38363323.svg";